import { useState, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Controller, Control } from "react-hook-form";

interface InputFieldProps {
  name: string;
  type?: string;
  label: string;
  control: Control<any>;
  required?: boolean;
  placeholder?: string;
  pattern?: { value: RegExp; message: string };
  error?: string;
  value?: string;
  rules?: any;
  sanitize?: (value: string) => string;
}

const labelVariants = {
  initial: { y: 10, scale: 1, opacity: 0.6 },
  float: {
    y: -16,
    scale: 0.85,
    opacity: 1,
    transition: { duration: 0.2 },
  },
};

const InputField = ({
  name,
  type = "text",
  label,
  control,
  required = false,
  // placeholder,
  pattern,
  error,
  // value = "",
  rules = {},
  sanitize
}: InputFieldProps) => {
  const [isFocused, setIsFocused] = useState(false);
  // const [hasValue, setHasValue] = useState(Boolean(value));
  const inputRef = useRef<HTMLInputElement | null>(null);

  // useEffect(() => {
  //   setHasValue(Boolean(value));
  // }, [value]);

  // useEffect(() => {
  //   const checkAutofill = () => {
  //     const val = inputRef.current?.value;
  //     if (val) setHasValue(true);
  //   };

  //   const timeout = setTimeout(checkAutofill, 300);
  //   return () => clearTimeout(timeout);
  // }, []);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => {
    setIsFocused(false);
    // setHasValue(!!e.target.value);
  };

  return (
    <div className="relative w-full">
      <motion.label
        className="absolute left-2 top-[3px] px-1 bg-white text-sm font-medium text-gray-600 pointer-events-none"
        variants={labelVariants}
        // initial={hasValue ? "float" : "initial"}
        initial={false}
        animate={isFocused || !!control._formValues[name] ? "float" : "initial"}
      >
        {label}
        {required && <span className="text-orange"> *</span>}
      </motion.label>

      <Controller
        name={name}
        control={control}
        rules={{
          required: required && `${label} is required`,
          pattern: pattern,
          ...rules
        }}
        render={({ field, fieldState }) => (
          <input
            {...field}
            type={type}
            placeholder=""
            className={`w-full px-4 py-3 border text-sm rounded-md border-inkBlack focus:outline-none focus:ring-2 focus:ring-orange focus:border-transparent ${
              (error || fieldState.error) ? "border-red-500" : ""
            }`}
            onFocus={handleFocus}
            onBlur={() => {
              handleBlur();
              field.onBlur();
            }}
            ref={inputRef}
            onChange={(e) => {
              const rawValue = e.target.value;
              const sanitizedValue = sanitize ? sanitize(rawValue) : rawValue; // ✅ Use sanitization
              field.onChange(sanitizedValue);
            }}
            value={field.value}
          />
        )}
      />

      <AnimatePresence>
        {(error || control._formState.errors[name]) && (
          <motion.p
            className="text-xs text-red-500 mt-1"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {error || (control._formState.errors[name] as any)?.message}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};

export default InputField;
